import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

// Serivces
import { DataService } from '../../services/data.service';

import * as moment from 'moment';

@Component({
	selector: 'app-contract-terms-free-trial-modal',
	templateUrl: './contract-terms-free-trial-modal.component.html',
})
export class ContractTermsFreeTrialModalComponent {

    schoolName: string;
    startDate: Date;
    trialExpiration: Date;

    constructor (
        public dataSvc: DataService,
        public bsModalRef: BsModalRef
    ) { 
       
    }

    dismissModal() {
        this.bsModalRef.hide();
    }

    printElement() {
        let elem = document.getElementById('print-this')
        var domClone = elem.cloneNode(true);
    
        // var $printSection = document.getElementById("printSection");
    
        // if (!$printSection) {
            var $printSection = document.createElement("div");
            $printSection.id = "printSection";
            document.body.appendChild($printSection);
        // }
    
        // if (append !== true) {
        //     $printSection.innerHTML = "";
        // }
    
        // else if (append === true) {
        //     if (typeof(delimiter) === "string") {
        //         $printSection.innerHTML += delimiter;
        //     }
        //     else if (typeof(delimiter) === "object") {
        //         $printSection.appendChlid(delimiter);
        //     }
        // }
    
        $printSection.appendChild(domClone);
        window.print();
    }
}
